import { Stack } from "@fluentui/react";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

interface FlagProps {
    label: string;
    value?: number;
}
const FlagIndicator = ({ label, value }: FlagProps) => {
    if (value !== 1 && value !== 0) return null;
    return (
        <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 6 }}>
            {value === 1 && (
                <CheckIcon sx={{ color: "green", fontSize: "1.3rem" }} aria-hidden="true" />
            )}
            {value === 0 && (
                <CloseIcon sx={{ color: "red", fontSize: "1.3rem" }} aria-hidden="true" />
            )}
            <span>{label}</span>
        </Stack>
    );
};

export default FlagIndicator;
